import MVVMBase from "../../framework/core/mvvm/mvvm_base";
import ModelData from "../public/model_data";
import EventManager from "../../manager/event_manager";
import { Hallx } from "../hall/server/club/proto_club_hall_notify";
import GameUtil from '../../utility/game_util';
import UserDataManager from "../../manager/user_manager";
import LoaclStorage from "../../manager/local_storage";
import AppData from "../public/const/app_data";
import Utility from "../../utility/utility";

class ClubUtils  {

    private _avatarId : number = 0;
    get avatarId(){

        if (!this._avatarId) {
            this._avatarId = ModelData.instance.roleData.id;    
        }
        return this._avatarId;
    }  
        
    private _clubId : number;
    public get clubId() : number {
        return this._clubId;
    }

    
    private _iconStyle : number;
    public get iconStyle() : number {
        return this._iconStyle;
    }
     
    
    private _clubInfo : any;
    public get clubInfo() : any {
        return this._clubInfo;
    }    

    
    private _isAdmin : boolean;
    public get isAdmin() : boolean {
        return this._isAdmin;
    }

    
    private _isOwner : boolean;
    public get isOwner() : boolean {
        return this._isOwner;
    }
 

    /**
     * 成员列表
     */ 
    private _memberList : any[];
    public get memberList() : any[] {
        return this._memberList;
    }

    public getMember(index : number){
        return this._memberList[index];
    }

    
    private _searchMemberList : any[];
    public get searchMemberList() : any[] {
        return this._searchMemberList;
    }

    private _searchAuditList : any[];
    public get searchAuditList() : any[] {
        return this._searchAuditList;
    }

    
    /**
     * 玩家审核列表
     */
    private _auditList : any[];
    public get auditList() : any[] {
        return this._auditList;
    }

    public getAudit(index : number){
        return this._auditList[index]
    }

    /**
     * 成员日志
     */
    private _logList : any[];
    public get logList() : any[] {
        return this._logList;
    }

    /**
     * 大厅数据
     */    
    private _hallList : any[];
    public get hallList() : any[] {
        return this._hallList;
    } 
    
    /**
     * 俱乐部初始化
     */
    init(data : any){
        
        this._clubId = data.userClubId;        
        this._clubInfo = data;

        this._isOwner = data.ownerUserId == this.avatarId;

        ModelData.instance.clubId = data.userClubId;
        this.autoBindCode()
        
        //EventManager.instance.on("club_member_update_rank",this.on_club_member_update_rank,this,true);        
    }

    getTalbeMaxNum(gameName : string){

        switch(gameName){
            case "CLUB_BJL"://百家乐
            case "CLUB_LHD"://龙虎斗
            case "CLUB_YXX"://鱼虾蟹
            case "CLUB_TB"://骰宝 
            case "CLUB_CP"://彩票  
            case "CLUB_SLOT":     
            case "CLUB_JK":                              
                return 8;                                                 
            case "CLUB_JD"://九点
            case "CLUB_DZPK"://德州扑克
                return 7;
            case "CLUB_BP"://比牌
            case "CLUB_BPZD":
            case "CLUB_HJK"://21点
                return 5;                
            case "CLUB_QZNN"://牛牛
            case "CLUB_Q2"://Q2
                return 4;                               
        }

        return 0;
    }


    clear(){

        this._clubId = 0;
        this._clubInfo = null;

        ModelData.instance.clubId = 0;
    }

    reqClubIcon(mvvm : MVVMBase, callback : (style : number)=>void) {

        let self = this;
        this.reqClubList(mvvm,(data)=>{
            if (data.length) {
                
                for (let index = 0; index < data.length; index++) {
                    const clubInfo = data[index];
                    if (clubInfo.userClubId == self.clubId) {
                        
                        let desc = JSON.parse(clubInfo.desc);                  
                        self._iconStyle = desc.logo?  Number(desc.logo): 1;
                        if (callback) {                            
                            callback( self._iconStyle );   
                        }                        
                        return;
                    }
                }
            }

            if (callback) {
                callback(1);
            }
        });
    }


    /**
     * 请求俱乐部列表
     * @param mvvm 
     * @param callback 
     */
    reqClubList(mvvm : MVVMBase,callback : (data : any)=>void){

        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "club/user/getGameUserClubList?",
            params: {
                gameUserId: ModelData.instance.roleData.id,
            },
            showNetPrompt:true
        }
        mvvm.apiHttpGet(requestData, (respone) => {

            if (callback) {
                callback(respone.data);
            }
        })
    }


    /**
     * 获取大厅列表
     * @param clubId 
     * @param mvvmBase 
     * @param callback 
     */
    reqClubHallList(clubId : number,mvvmBase : MVVMBase,callback : Function){

        let requestData : IHttpRequestData = {

            baseUrl : 'club/hall/getHallList?',
            params : {
                clubId : clubId,
                gameUserId : this.avatarId,
            }
           
        }
        let self = this;
        mvvmBase.apiHttpGet(requestData,(response)=>{
            if(response.code == 'SUCCESS'){
                self._hallList = response.data;
                if (callback) {
                    callback(response.data);
                }

            }else{

                if (callback) {
                    callback(null);
                }
            }
        })
    }



    

    private on_club_member_update_rank(index:number,data : any){

        if (data.gameUserId == this.avatarId) {
            
            this._isAdmin = data.clubUserType == "admin" || data.clubUserType == "owner";
        }        
    }


    //加入审核
    reqAcceptJoinClub(success : boolean, index : number, mvvmBase : MVVMBase,callback :( success : boolean)=>void){

        let requestData : IHttpRequestData = {

            baseUrl : 'club/manager/auditApply?',
            params : {
                gameUserId : this.avatarId,
                success : success,
                userClubUserAuditId : this.getAudit(index).userClubUserAuditId,
            }
           
        }
        let self = this;
        mvvmBase.apiHttpGet(requestData,(response )=>{

            console.log(`${requestData.baseUrl}` , response);
            if (response.code == 'SUCCESS') {   
            
                if (callback) {
                    callback(true)
                }

            }else{
                if (callback) {
                    callback(false)
                }
            }
        });   
    }

    /**
     * 玩法列表
     */
    reqGameList( mvvmBase : MVVMBase,callback :( friendList : any[])=>void){

        let requestData : IHttpRequestData = {

            baseUrl : 'club/user/getClubGoldList?',
            params : {
                userClubId : this.clubId,
            }
           
        }
        let self = this;
        mvvmBase.apiHttpGet(requestData,(response : any)=>{

            console.log(`${requestData.baseUrl}` , response);
            if (response.code == 'SUCCESS' && response.data) {   
            
            }
        });   
    }

    //已有成员列表
    public reqMemberList(pageNum : number, mvvmBase : MVVMBase,callback :( datalist : any[])=>void,queryUserId? : number,addItem? : boolean){

        let requestData : IHttpRequestData = {
            
            baseUrl : 'club/user/queryUserPage?',
            params : {
                gameUserId : this.avatarId,
                pageNum : pageNum,
                userClubId : this.clubId,
            }
        }

        if (queryUserId) {
            requestData.params["queryUserId"] = queryUserId;
        }

        let self = this;
        mvvmBase.apiHttpGet(requestData,(response : any)=>{

            console.log(`${requestData.baseUrl}` , response);
            if (response.code == 'SUCCESS' && response.data) {   

                if (queryUserId) {
                    self._searchMemberList = response.data.list;
                }else{
                    if (addItem) {
                        self._memberList.concat(response.data.list);
                    }else{
                        self._memberList = response.data.list;
                    }                    
                }
                if (callback) {
                    callback(response.data.list);    
                }                
            }
        });   
    }


    //成员审核列表
    reqAuditList( pageNum : number,mvvmBase : MVVMBase, callback :( datalist : any[])=>void,queryUserId? : number,addItem? : boolean){

        let requestData : IHttpRequestData = {
            
            baseUrl : 'club/manager/getGameUserAuditingList?',
            params : {
                gameUserId : this.avatarId,
                pageNum : pageNum,
                userClubId : this.clubId,
            }            
        }

        if (queryUserId) {
            requestData.params["queryUserId"] = queryUserId;
        }

        let self = this;
        mvvmBase.apiHttpGet(requestData,(response : any)=>{

            console.log(`${requestData.baseUrl}` , response);
            if (response.code == 'SUCCESS' && response.data) {   
                                           
                if (queryUserId) {
                    self._searchAuditList = response.data;    
                }else{
                    if (addItem) {
                        self._auditList.concat(response.data);    
                    }else{
                        self._auditList = response.data;    
                    }                    
                }
                
                if (callback) {
                    callback(response.data);
                }
            }
        });   

    }

    //成员日志
    reqLogList( pageNum : number,mvvmBase : MVVMBase, callback :( datalist : any[])=>void,addItem? : boolean){

        let requestData : IHttpRequestData = {

            baseUrl : 'club/manager/getQplogPage?',
            params : {
                gameUserId : this.avatarId,
                pageNum : pageNum,
                userClubId : this.clubId,
            }
        }


        let self = this;
        mvvmBase.apiHttpGet(requestData,(response : any)=>{

            console.log(`${requestData.baseUrl}` , response);
            if (response.code == 'SUCCESS' && response.data) {   

                if (addItem) {
                    self._logList.concat(response.data);
                }else{
                    self._logList = response.data;
                }
                
                if (callback) {
                    callback(response.data);    
                }                
            }
        });   

    }

    //移出俱乐部
    reqRemoveClub(index : number,mvvmBase : MVVMBase, callback? : ( success : boolean)=>void){
        
        let requestData : IHttpRequestData = {
        
            baseUrl : 'club/manager/removeClubUser?',
            params : {
                gameUserId : this.avatarId,
                targetUserId : this.getMember(index).gameUserId,
                userClubId : this.clubId,
            }
            
        }
        let self = this;
        mvvmBase.apiHttpGet(requestData,(response : any)=>{

            console.log( `${requestData.baseUrl}`, response);
            if (response.code == 'SUCCESS' && response.data) {   
            
                self._memberList.splice(index,1);

                if (callback) {
                    callback(true);
                }
            }else{
                callback(false);
            }
        });           
    }

   
    /**
     * 提升成员
     */
    reqUpgradeMember( index : number,mvvmBase : MVVMBase, callback? : ( success : boolean)=>void){

        let requestData : IHttpRequestData = {
        
            baseUrl : 'club/manager/levelUpClubUser?',
            params : {
                gameUserId : this.avatarId,
                targetUserId : this.getMember(index).gameUserId,
                userClubId : this.clubId,
            }
            
        }
        let self = this;
        mvvmBase.apiHttpGet(requestData,(response : any)=>{

            console.log(`${requestData.baseUrl}` , response);
            if (response.code == 'SUCCESS' && response.data) {   
            
                if (callback) {
                    callback(true);
                }
            }else{
                callback(false);
            }
        });           
    }

    /**
     * 降级成员
     */
    reqDownMember( index : number,mvvmBase : MVVMBase, callback? : ( success : boolean)=>void){

        let requestData : IHttpRequestData = {
        
            baseUrl : 'club/manager/levelDownClubUser?',
            params : {
                gameUserId : this.avatarId,
                targetUserId : this.getMember(index).gameUserId,
                userClubId : this.clubId,
            }
            
        }
        let self = this;
        mvvmBase.apiHttpGet(requestData,(response : any)=>{

            console.log(`${requestData.baseUrl}` , response);
            if (response.code == 'SUCCESS' && response.data) {   

                if (callback) {
                    callback(true);
                }
            }else{
                callback(false);
            }
        });           
    }

    /**
     * 设置筹码
     */
    reqSetBalance( coins : number, index : number,mvvmBase : MVVMBase, callback? : ( success : number)=>void){

        let requestData : IHttpRequestData = {
        
            baseUrl : 'club/manager/changBalance?',
            params : {
                coins : coins,
                gameUserId : this.avatarId,
                targetUserId : this.getMember(index).gameUserId,
                userClubId : this.clubId,
            }            
        }

        mvvmBase.apiHttpGet(requestData,(response : any)=>{

            console.log(`${requestData.baseUrl}` , response);
            if (response.code == 'SUCCESS' && response.data) {   
            
                if (callback) {
                    callback(response.data.balance);
                }
            }
        });           
    }

    //自动绑定code
    autoBindCode() {
        if (ModelData.instance.roleData.parentId > 0) { return }
        //如果跟上次错误的code一样 就不请求了
        if (AppData.openInstallData && AppData.openInstallData.code.toString() != LoaclStorage.getString("ERROR_CODE_ENVI_" + AppData.userConnectEnvi)) {
            let inviteCode = AppData.openInstallData.code.toString()
            if (inviteCode && inviteCode.length > 0){
                if (inviteCode.length == 3 || inviteCode.length == 8 ){
                    this._bindInviteIDCode(inviteCode)
                }
                else{
                    this._bindInviteCode(inviteCode)
                }
            }
        }
    }

    //绑定id邀请码，如果一个设备号上自动绑定了一个号，之后的账号不会再自动绑定
    private _bindInviteIDCode(parentId){
        let requestData: IHttpRequestData = {
            baseUrl: "promoters/bindParentId?",
            params: {
                parentId:parentId
            }
        }
        GameUtil.apiHttpGet(requestData, (retData) => {
            ModelData.instance.setRoleParentId(parentId)
            LoaclStorage.setString("ERROR_CODE_ENVI_" + AppData.userConnectEnvi, parentId)
            EventManager.instance.dispatch("event_bind_code")
        }, (error) => {
            if (error.code == "X00150" || error.code == "B00036" || error.code == "U00048") {
                LoaclStorage.setString("ERROR_CODE_ENVI_" + AppData.userConnectEnvi, parentId)
            }
        })
    }

    //绑定邀请码，如果一个设备号上自动绑定了一个号，之后的账号不会再自动绑定
    private _bindInviteCode(inviteCode){
        let requestData: IHttpRequestData = {
            baseUrl: "promoters/bindInviteCode?",
            params: {
                inviteCode:inviteCode
            }
        }
        GameUtil.apiHttpGet(requestData, (retData) => {
            UserDataManager.getData(ModelData.instance.roleData.id, null, true)
            EventManager.instance.dispatch("event_bind_code")
            LoaclStorage.setString("ERROR_CODE_ENVI_" + AppData.userConnectEnvi, inviteCode)
        }, (error) => {
            //"U00048" 上级不是推广员
            if (error.code == "X00150" || error.code == "B00036" || error.code == "U00048") {
                LoaclStorage.setString("ERROR_CODE_ENVI_" + AppData.userConnectEnvi, inviteCode)
            }
        })
    }


    //申请进入俱乐部
    autoJoinClub(clubCode, callback ?: (erry : any, joinSucess : boolean) => void){
        if (clubCode == null || clubCode == 0){ 
            callback && callback("error clubId", null)
            return 
        }
        let autoJonCLUBID = LoaclStorage.getNumber("AUTO_JOIN_CLUB_ID", 0, true)
        if (autoJonCLUBID == clubCode) { //已经处理过了
            callback && callback("autoJoinClubIdHasProcess", null)
            return 
        }
        let requestData: IHttpRequestData = {
            baseUrl: "club/user/applyJoin?",
            params: {
                clubNum:clubCode,
            },
        }
        GameUtil.apiHttpGet(requestData, (respone) => {
            LoaclStorage.setNumber("AUTO_JOIN_CLUB_ID", clubCode, true)
            callback && callback(null, true)
            Utility.reportConversionEvent("event_auto_join_club", clubCode)
            // self.onButtonClub()
        }, (error) => {
            if (error.code == "U00032") { //无法重复加入，代表已经加入了
                LoaclStorage.setNumber("AUTO_JOIN_CLUB_ID", clubCode, true)
            }
            callback && callback(error, null)
        })
    }





    getUserClubList(callback : (erry : any, data : any) => void) {
        let requestData: IHttpRequestData = {
            baseUrl: "club/user/getGameUserClubList?",
            params: {
                gameUserId: ModelData.instance.roleData.id,
            },
            showNetPrompt:true
        }
        GameUtil.apiHttpGet(requestData, (respone) => {
            callback(null, respone.data)
        }, (error) => {
            callback(error, null)
        })
    }

    getUserClubListWithId(clubId, callback : (erry : any, data : any) => void) {
        this.getUserClubList((error, data) => {
            if (data) {
                let enterClubData
                for (let index = 0; index < data.length; index++) {
                    if (clubId == data[index].userClubId){
                        enterClubData = data[index]
                        callback(null, data[index])
                        break;
                    }
                }
                if (enterClubData == null) {
                    if (data.length == 1) {
                        callback(null, data[0])
                    } else {
                        callback("No Data", null)
                    }
                }
            } else {
                callback(error, null)
            }

        })
    }
}



export let club_utils = new ClubUtils();
